import {
    RequestConfigFunction,
} from 'app/types/request.types'

import {
    LongTermLeaseInvoiceTable,
} from './LongTermLease.types'

type LongTermLeaseInvoicesRequests = {
    filterRequestAll: RequestConfigFunction<{
        longTermLeaseId: number, params?: Record<string, any>
    }, LongTermLeaseInvoiceTable[]>,
    createLongTermLeaseInvoice: RequestConfigFunction<{
        longTermLeaseId: number, params?: Record<string, any>
    }>,
}

const longTermLeaseInvoicesRequests: LongTermLeaseInvoicesRequests = {
    filterRequestAll: (params) => {
        return {
            url: `longtermlease/${params?.longTermLeaseId}/longtermleaseinvoice/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    createLongTermLeaseInvoice: ({
        longTermLeaseId,
        params,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/longtermleaseinvoice`,
            method: 'POST',
            ...params,
        }
    },

}

export default longTermLeaseInvoicesRequests
